import { render, staticRenderFns } from "./addStore.vue?vue&type=template&id=2e45b230&scoped=true&"
import script from "./addStore.vue?vue&type=script&lang=js&"
export * from "./addStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e45b230",
  null
  
)

export default component.exports